// TODO AUTH GUARD, MAKE VIEW

<template>
  <v-container fill-height fluid>
    <v-col class="text-center" cols="12">
      <div class='pa-2'>
        <v-btn @click="logout">Logout</v-btn>
      </div>
      <div class='pa-2'>
        <v-btn @click="changeTheme">
        <span>Theme</span>
          <v-icon >mdi-theme-light-dark</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-container>
</template>

<script>
import firebase from "firebase";
export default {
  methods: {
    logout: function() {
        firebase.auth().signOut().then(() => {
          this.$router.replace({ name: "Dashboard" });
        })
      },
    changeTheme: function() {
        this.$store.commit('changeTheme');
        this.$vuetify.theme.dark = this.$store.getters.darkmode;
      },
  }
}
</script>